import "bootstrap/dist/css/bootstrap.min.css";
import MathTable from "components/tables/MathTable";
import React from "react";
import { Card, Col } from "react-bootstrap";

const SBASContinuityCard = ({ innerRef, data }) => {
  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Continuity
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          The continuity of service is the capability of a system to perform its
          function without unscheduled interruptions during the intended
          operation. This KPI is calculated over a one-month interval, ending
          with the 14 days reporting period.
        </p>
        <p className="text-justify">
          The thresholds are the minimum continuity performance values declared
          in the EGNOS Safety of Life Service Definition Document. The ranges
          take into account the geographical location of the receiver, with the
          lowest value corresponding to central locations of the ECAC area and
          the highest value corresponding to marginal locations.
        </p>

        {data.satellites.map((satellite, index) => (
          <React.Fragment key={index}>
            <p className="text-justify">
              Continuity of service with SBAS GEO {satellite.prn}
            </p>
            <Col
              sm={{ span: 12, offset: 0 }}
              md={{ span: 5, offset: 1 }}
              xxl={{ span: 6, offset: 1 }}
            >
              <MathTable data={satellite.table} />
            </Col>
          </React.Fragment>
        ))}
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <SBASContinuityCard innerRef={ref} {...props} />
  ))
);
